var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7099 8.20986C18.6169 8.11613 18.5063 8.04174 18.3845 7.99097C18.2626 7.9402 18.1319 7.91406 17.9999 7.91406C17.8679 7.91406 17.7372 7.9402 17.6153 7.99097C17.4934 8.04174 17.3828 8.11613 17.2899 8.20986L12.7099 12.7899C12.6169 12.8836 12.5063 12.958 12.3845 13.0087C12.2626 13.0595 12.1319 13.0856 11.9999 13.0856C11.8679 13.0856 11.7372 13.0595 11.6153 13.0087C11.4934 12.958 11.3828 12.8836 11.2899 12.7899L6.70988 8.20986C6.61691 8.11613 6.50631 8.04174 6.38445 7.99097C6.26259 7.9402 6.13189 7.91406 5.99988 7.91406C5.86787 7.91406 5.73716 7.9402 5.6153 7.99097C5.49344 8.04174 5.38284 8.11613 5.28988 8.20986C5.10363 8.39722 4.99908 8.65067 4.99908 8.91486C4.99908 9.17904 5.10363 9.4325 5.28988 9.61986L9.87988 14.2098C10.4424 14.7716 11.2049 15.0872 11.9999 15.0872C12.7949 15.0872 13.5574 14.7716 14.1199 14.2098L18.7099 9.61986C18.8961 9.4325 19.0007 9.17904 19.0007 8.91486C19.0007 8.65067 18.8961 8.39722 18.7099 8.20986Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiDown);
export default __webpack_public_path__ + "static/media/fi_down.c96fa6c2f854fec77f9fb43a6a433986.svg";
export { ForwardRef as ReactComponent };